import { render, staticRenderFns } from "./study-completion.vue?vue&type=template&id=5fb9ab69&"
import script from "./study-completion.vue?vue&type=script&lang=js&"
export * from "./study-completion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "study-completion.vue"
export default component.exports